import React, { useEffect, useState } from 'react'
import './YoutubeList.scss';

function YoutubeList(props) {

    return (
        <div className='youtube-list'>
            <iframe src={"https://www.youtube.com/embed/videoseries?list=" + props.youtubeList.url} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
    )
}

export default YoutubeList